export const Stepper = ({ children, currentStep }: any) => {
	return <>{children.filter(Boolean)[currentStep]}</>;
};
